const startingState = {
  date: "2022-06-09",
  date_epoch: 1654732800,
  day: {
    maxtemp_c: 46.8,
    maxtemp_f: 116.2,
    mintemp_c: 27.7,
    mintemp_f: 81.9,
    avgtemp_c: 36.4,
    avgtemp_f: 97.4,
    maxwind_mph: 13.6,
    maxwind_kph: 22,
    totalprecip_mm: 0,
    totalprecip_in: 0,
    avgvis_km: 10,
    avgvis_miles: 6,
    avghumidity: 13,
    daily_will_it_rain: 0,
    daily_chance_of_rain: 0,
    daily_will_it_snow: 0,
    daily_chance_of_snow: 0,
    condition: {
      text: "Sunny",
      icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      code: 1000,
    },
    uv: 11,
  },
  astro: {
    sunrise: "05:19 AM",
    sunset: "07:27 PM",
    moonrise: "01:54 PM",
    moonset: "01:36 AM",
    moon_phase: "Waxing Gibbous",
    moon_illumination: "69",
  },
  hour: [
    {
      time_epoch: 1654713000,
      time: "2022-06-09 00:00",
      temp_c: 29.2,
      temp_f: 84.6,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 6.5,
      wind_kph: 10.4,
      wind_degree: 109,
      wind_dir: "ESE",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 16,
      cloud: 21,
      feelslike_c: 27.1,
      feelslike_f: 80.8,
      windchill_c: 29.2,
      windchill_f: 84.6,
      heatindex_c: 27.1,
      heatindex_f: 80.8,
      dewpoint_c: 0.9,
      dewpoint_f: 33.6,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 13.6,
      gust_kph: 22,
      uv: 1,
    },
    {
      time_epoch: 1654716600,
      time: "2022-06-09 01:00",
      temp_c: 28.6,
      temp_f: 83.5,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 7.2,
      wind_kph: 11.5,
      wind_degree: 112,
      wind_dir: "ESE",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 18,
      cloud: 13,
      feelslike_c: 26.5,
      feelslike_f: 79.7,
      windchill_c: 28.6,
      windchill_f: 83.5,
      heatindex_c: 26.5,
      heatindex_f: 79.7,
      dewpoint_c: 1.9,
      dewpoint_f: 35.4,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 15,
      gust_kph: 24.1,
      uv: 1,
    },
    {
      time_epoch: 1654720200,
      time: "2022-06-09 02:00",
      temp_c: 29.5,
      temp_f: 85.1,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 7.6,
      wind_kph: 12.2,
      wind_degree: 114,
      wind_dir: "ESE",
      pressure_mb: 997,
      pressure_in: 29.45,
      precip_mm: 0,
      precip_in: 0,
      humidity: 19,
      cloud: 10,
      feelslike_c: 27.3,
      feelslike_f: 81.1,
      windchill_c: 29.5,
      windchill_f: 85.1,
      heatindex_c: 27.3,
      heatindex_f: 81.1,
      dewpoint_c: 3.8,
      dewpoint_f: 38.8,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 15.9,
      gust_kph: 25.6,
      uv: 1,
    },
    {
      time_epoch: 1654723800,
      time: "2022-06-09 03:00",
      temp_c: 28.9,
      temp_f: 84,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 7.4,
      wind_kph: 11.9,
      wind_degree: 106,
      wind_dir: "ESE",
      pressure_mb: 997,
      pressure_in: 29.45,
      precip_mm: 0,
      precip_in: 0,
      humidity: 21,
      cloud: 7,
      feelslike_c: 26.9,
      feelslike_f: 80.4,
      windchill_c: 28.9,
      windchill_f: 84,
      heatindex_c: 26.9,
      heatindex_f: 80.4,
      dewpoint_c: 4.2,
      dewpoint_f: 39.6,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 15.4,
      gust_kph: 24.8,
      uv: 1,
    },
    {
      time_epoch: 1654727400,
      time: "2022-06-09 04:00",
      temp_c: 28.3,
      temp_f: 82.9,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 6.7,
      wind_kph: 10.8,
      wind_degree: 95,
      wind_dir: "E",
      pressure_mb: 998,
      pressure_in: 29.46,
      precip_mm: 0,
      precip_in: 0,
      humidity: 22,
      cloud: 6,
      feelslike_c: 26.4,
      feelslike_f: 79.5,
      windchill_c: 28.3,
      windchill_f: 82.9,
      heatindex_c: 26.4,
      heatindex_f: 79.5,
      dewpoint_c: 4.3,
      dewpoint_f: 39.7,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 14.1,
      gust_kph: 22.7,
      uv: 1,
    },
    {
      time_epoch: 1654731000,
      time: "2022-06-09 05:00",
      temp_c: 27.7,
      temp_f: 81.9,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 6.5,
      wind_kph: 10.4,
      wind_degree: 93,
      wind_dir: "E",
      pressure_mb: 998,
      pressure_in: 29.47,
      precip_mm: 0,
      precip_in: 0,
      humidity: 22,
      cloud: 5,
      feelslike_c: 26,
      feelslike_f: 78.8,
      windchill_c: 27.7,
      windchill_f: 81.9,
      heatindex_c: 26,
      heatindex_f: 78.8,
      dewpoint_c: 4.2,
      dewpoint_f: 39.6,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 13.6,
      gust_kph: 22,
      uv: 7,
    },
    {
      time_epoch: 1654734600,
      time: "2022-06-09 06:00",
      temp_c: 29.7,
      temp_f: 85.5,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 5.1,
      wind_kph: 8.3,
      wind_degree: 89,
      wind_dir: "E",
      pressure_mb: 999,
      pressure_in: 29.49,
      precip_mm: 0,
      precip_in: 0,
      humidity: 20,
      cloud: 5,
      feelslike_c: 27.5,
      feelslike_f: 81.5,
      windchill_c: 29.7,
      windchill_f: 85.5,
      heatindex_c: 27.5,
      heatindex_f: 81.5,
      dewpoint_c: 4.6,
      dewpoint_f: 40.3,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 9.6,
      gust_kph: 15.5,
      uv: 7,
    },
    {
      time_epoch: 1654738200,
      time: "2022-06-09 07:00",
      temp_c: 33.9,
      temp_f: 93,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 4.7,
      wind_kph: 7.6,
      wind_degree: 110,
      wind_dir: "ESE",
      pressure_mb: 999,
      pressure_in: 29.5,
      precip_mm: 0,
      precip_in: 0,
      humidity: 16,
      cloud: 7,
      feelslike_c: 31.9,
      feelslike_f: 89.4,
      windchill_c: 33.9,
      windchill_f: 93,
      heatindex_c: 31.9,
      heatindex_f: 89.4,
      dewpoint_c: 4.9,
      dewpoint_f: 40.8,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 5.4,
      gust_kph: 8.6,
      uv: 8,
    },
    {
      time_epoch: 1654741800,
      time: "2022-06-09 08:00",
      temp_c: 36.7,
      temp_f: 98.1,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 5.8,
      wind_kph: 9.4,
      wind_degree: 172,
      wind_dir: "S",
      pressure_mb: 999,
      pressure_in: 29.51,
      precip_mm: 0,
      precip_in: 0,
      humidity: 15,
      cloud: 9,
      feelslike_c: 35.3,
      feelslike_f: 95.5,
      windchill_c: 36.7,
      windchill_f: 98.1,
      heatindex_c: 35.3,
      heatindex_f: 95.5,
      dewpoint_c: 5.7,
      dewpoint_f: 42.3,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 6.7,
      gust_kph: 10.8,
      uv: 9,
    },
    {
      time_epoch: 1654745400,
      time: "2022-06-09 09:00",
      temp_c: 38.5,
      temp_f: 101.3,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 8.3,
      wind_kph: 13.3,
      wind_degree: 204,
      wind_dir: "SSW",
      pressure_mb: 999,
      pressure_in: 29.5,
      precip_mm: 0,
      precip_in: 0,
      humidity: 13,
      cloud: 11,
      feelslike_c: 37.8,
      feelslike_f: 100,
      windchill_c: 38.5,
      windchill_f: 101.3,
      heatindex_c: 37.8,
      heatindex_f: 100,
      dewpoint_c: 5.7,
      dewpoint_f: 42.3,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 9.6,
      gust_kph: 15.5,
      uv: 9,
    },
    {
      time_epoch: 1654749000,
      time: "2022-06-09 10:00",
      temp_c: 39.8,
      temp_f: 103.6,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 8.7,
      wind_kph: 14,
      wind_degree: 209,
      wind_dir: "SSW",
      pressure_mb: 999,
      pressure_in: 29.49,
      precip_mm: 0,
      precip_in: 0,
      humidity: 12,
      cloud: 9,
      feelslike_c: 39.6,
      feelslike_f: 103.3,
      windchill_c: 39.8,
      windchill_f: 103.6,
      heatindex_c: 39.6,
      heatindex_f: 103.3,
      dewpoint_c: 5.5,
      dewpoint_f: 41.9,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 10.1,
      gust_kph: 16.2,
      uv: 9,
    },
    {
      time_epoch: 1654752600,
      time: "2022-06-09 11:00",
      temp_c: 44.2,
      temp_f: 111.6,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 6.3,
      wind_kph: 10.1,
      wind_degree: 216,
      wind_dir: "SW",
      pressure_mb: 998,
      pressure_in: 29.47,
      precip_mm: 0,
      precip_in: 0,
      humidity: 11,
      cloud: 0,
      feelslike_c: 46.6,
      feelslike_f: 115.9,
      windchill_c: 44.2,
      windchill_f: 111.6,
      heatindex_c: 46.6,
      heatindex_f: 115.9,
      dewpoint_c: 6.9,
      dewpoint_f: 44.4,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 7.2,
      gust_kph: 11.5,
      uv: 10,
    },
    {
      time_epoch: 1654756200,
      time: "2022-06-09 12:00",
      temp_c: 45.5,
      temp_f: 113.9,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 7.2,
      wind_kph: 11.5,
      wind_degree: 241,
      wind_dir: "WSW",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 10,
      cloud: 0,
      feelslike_c: 48.8,
      feelslike_f: 119.8,
      windchill_c: 45.5,
      windchill_f: 113.9,
      heatindex_c: 48.8,
      heatindex_f: 119.8,
      dewpoint_c: 6,
      dewpoint_f: 42.8,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.3,
      gust_kph: 13.3,
      uv: 11,
    },
    {
      time_epoch: 1654759800,
      time: "2022-06-09 13:00",
      temp_c: 46.2,
      temp_f: 115.2,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 8.5,
      wind_kph: 13.7,
      wind_degree: 252,
      wind_dir: "WSW",
      pressure_mb: 996,
      pressure_in: 29.4,
      precip_mm: 0,
      precip_in: 0,
      humidity: 8,
      cloud: 0,
      feelslike_c: 50.1,
      feelslike_f: 122.2,
      windchill_c: 46.2,
      windchill_f: 115.2,
      heatindex_c: 50.1,
      heatindex_f: 122.2,
      dewpoint_c: 4.7,
      dewpoint_f: 40.5,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 9.8,
      gust_kph: 15.8,
      uv: 11,
    },
    {
      time_epoch: 1654763400,
      time: "2022-06-09 14:00",
      temp_c: 46.8,
      temp_f: 116.2,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 10.3,
      wind_kph: 16.6,
      wind_degree: 251,
      wind_dir: "WSW",
      pressure_mb: 995,
      pressure_in: 29.37,
      precip_mm: 0,
      precip_in: 0,
      humidity: 8,
      cloud: 10,
      feelslike_c: 51.1,
      feelslike_f: 124,
      windchill_c: 46.8,
      windchill_f: 116.2,
      heatindex_c: 51.1,
      heatindex_f: 124,
      dewpoint_c: 3.6,
      dewpoint_f: 38.5,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 11.9,
      gust_kph: 19.1,
      uv: 11,
    },
    {
      time_epoch: 1654767000,
      time: "2022-06-09 15:00",
      temp_c: 44.7,
      temp_f: 112.5,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 12.3,
      wind_kph: 19.8,
      wind_degree: 259,
      wind_dir: "W",
      pressure_mb: 994,
      pressure_in: 29.35,
      precip_mm: 0,
      precip_in: 0,
      humidity: 7,
      cloud: 17,
      feelslike_c: 47.4,
      feelslike_f: 117.3,
      windchill_c: 44.7,
      windchill_f: 112.5,
      heatindex_c: 47.4,
      heatindex_f: 117.3,
      dewpoint_c: 1.5,
      dewpoint_f: 34.7,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 14.1,
      gust_kph: 22.7,
      uv: 10,
    },
    {
      time_epoch: 1654770600,
      time: "2022-06-09 16:00",
      temp_c: 43.6,
      temp_f: 110.5,
      is_day: 1,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
        code: 1003,
      },
      wind_mph: 13.6,
      wind_kph: 22,
      wind_degree: 269,
      wind_dir: "W",
      pressure_mb: 994,
      pressure_in: 29.34,
      precip_mm: 0,
      precip_in: 0,
      humidity: 7,
      cloud: 28,
      feelslike_c: 45.6,
      feelslike_f: 114.1,
      windchill_c: 43.6,
      windchill_f: 110.5,
      heatindex_c: 45.6,
      heatindex_f: 114.1,
      dewpoint_c: 0.5,
      dewpoint_f: 32.9,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 15.7,
      gust_kph: 25.2,
      uv: 10,
    },
    {
      time_epoch: 1654774200,
      time: "2022-06-09 17:00",
      temp_c: 42.1,
      temp_f: 107.8,
      is_day: 1,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
        code: 1003,
      },
      wind_mph: 13.6,
      wind_kph: 22,
      wind_degree: 274,
      wind_dir: "W",
      pressure_mb: 993,
      pressure_in: 29.34,
      precip_mm: 0,
      precip_in: 0,
      humidity: 7,
      cloud: 33,
      feelslike_c: 43.1,
      feelslike_f: 109.6,
      windchill_c: 42.1,
      windchill_f: 107.8,
      heatindex_c: 43.1,
      heatindex_f: 109.6,
      dewpoint_c: -0.2,
      dewpoint_f: 31.6,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 15.7,
      gust_kph: 25.2,
      uv: 10,
    },
    {
      time_epoch: 1654777800,
      time: "2022-06-09 18:00",
      temp_c: 40.3,
      temp_f: 104.5,
      is_day: 1,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
        code: 1003,
      },
      wind_mph: 10.1,
      wind_kph: 16.2,
      wind_degree: 279,
      wind_dir: "W",
      pressure_mb: 994,
      pressure_in: 29.35,
      precip_mm: 0,
      precip_in: 0,
      humidity: 8,
      cloud: 45,
      feelslike_c: 40.4,
      feelslike_f: 104.7,
      windchill_c: 40.3,
      windchill_f: 104.5,
      heatindex_c: 40.4,
      heatindex_f: 104.7,
      dewpoint_c: -0.2,
      dewpoint_f: 31.6,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 15.4,
      gust_kph: 24.8,
      uv: 10,
    },
    {
      time_epoch: 1654781400,
      time: "2022-06-09 19:00",
      temp_c: 36.3,
      temp_f: 97.3,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 4.9,
      wind_kph: 7.9,
      wind_degree: 334,
      wind_dir: "NNW",
      pressure_mb: 995,
      pressure_in: 29.39,
      precip_mm: 0,
      precip_in: 0,
      humidity: 10,
      cloud: 46,
      feelslike_c: 34.8,
      feelslike_f: 94.6,
      windchill_c: 36.3,
      windchill_f: 97.3,
      heatindex_c: 34.8,
      heatindex_f: 94.6,
      dewpoint_c: 0,
      dewpoint_f: 32,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 10.3,
      gust_kph: 16.6,
      uv: 1,
    },
    {
      time_epoch: 1654785000,
      time: "2022-06-09 20:00",
      temp_c: 35,
      temp_f: 95,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 4.5,
      wind_kph: 7.2,
      wind_degree: 38,
      wind_dir: "NE",
      pressure_mb: 996,
      pressure_in: 29.42,
      precip_mm: 0,
      precip_in: 0,
      humidity: 11,
      cloud: 32,
      feelslike_c: 33.2,
      feelslike_f: 91.8,
      windchill_c: 35,
      windchill_f: 95,
      heatindex_c: 33.2,
      heatindex_f: 91.8,
      dewpoint_c: 0.3,
      dewpoint_f: 32.5,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 9.4,
      gust_kph: 15.1,
      uv: 1,
    },
    {
      time_epoch: 1654788600,
      time: "2022-06-09 21:00",
      temp_c: 33.8,
      temp_f: 92.8,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 3.8,
      wind_kph: 6.1,
      wind_degree: 65,
      wind_dir: "ENE",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 12,
      cloud: 27,
      feelslike_c: 31.8,
      feelslike_f: 89.2,
      windchill_c: 33.8,
      windchill_f: 92.8,
      heatindex_c: 31.8,
      heatindex_f: 89.2,
      dewpoint_c: 0.6,
      dewpoint_f: 33.1,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.1,
      gust_kph: 13,
      uv: 1,
    },
    {
      time_epoch: 1654792200,
      time: "2022-06-09 22:00",
      temp_c: 32.5,
      temp_f: 90.5,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 5.6,
      wind_kph: 9,
      wind_degree: 64,
      wind_dir: "ENE",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 13,
      cloud: 26,
      feelslike_c: 30.3,
      feelslike_f: 86.5,
      windchill_c: 32.5,
      windchill_f: 90.5,
      heatindex_c: 30.3,
      heatindex_f: 86.5,
      dewpoint_c: 1,
      dewpoint_f: 33.8,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 11.6,
      gust_kph: 18.7,
      uv: 1,
    },
    {
      time_epoch: 1654795800,
      time: "2022-06-09 23:00",
      temp_c: 30.7,
      temp_f: 87.3,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 4.9,
      wind_kph: 7.9,
      wind_degree: 68,
      wind_dir: "ENE",
      pressure_mb: 998,
      pressure_in: 29.46,
      precip_mm: 0,
      precip_in: 0,
      humidity: 16,
      cloud: 18,
      feelslike_c: 28.5,
      feelslike_f: 83.3,
      windchill_c: 30.7,
      windchill_f: 87.3,
      heatindex_c: 28.5,
      heatindex_f: 83.3,
      dewpoint_c: 2.1,
      dewpoint_f: 35.8,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 10.3,
      gust_kph: 16.6,
      uv: 1,
    },
  ],
};
const day2Reducer = (state = startingState, action) => {
  switch (action.type) {
    case "DAY2":
      return action.value;
    default:
      return state;
  }
};

export default day2Reducer;
